'use client'

import styled from "styled-components";

export const Page = styled.main`
  padding-top: ${({ theme }) => theme.rem(72)};

  ${({ theme }) => theme.mediaQuery.lg(`
    padding-top: ${theme.rem(114)};
  `)};
`